<div #divider class="tt-divider-columns">
    <ng-content></ng-content>
</div>
